import React, { useMemo, useState } from 'react';
import { Alert, List } from 'tea-component';
import { useIntl } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import './index.scss';

export type PrMarqueeLine = {
  content?: string;
  content_cn?: string;
};

export interface IPrMarqueeAlertProps {
  data?: Record<string, unknown>;
  /** Service 挂载的数据键，默认 prMarquee */
  dataKey?: string;
}

type PrMarqueeServiceBlock = {
  data?: { lines?: PrMarqueeLine[]; };
  loading?: boolean;
  errorMsg?: string;
};

/**
 * Studio PR 顶部跑马灯：样式对齐经分 MarqueeInfo，文案由接口/配置驱动，不依赖 dashboard model。
 */
const PrMarqueeAlert: React.FC<IPrMarqueeAlertProps> = (props) => {
  const { data, dataKey = 'prMarquee' } = props;
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const block = data?.[dataKey] as PrMarqueeServiceBlock | undefined;
  const lines = block?.data?.lines ?? [];
  const loading = Boolean(block?.loading);
  const isError = Boolean(block?.errorMsg) && !loading;

  const texts = useMemo(
    () =>
      lines
        .map((row) => (isEn ? row?.content ?? row?.content_cn : row?.content_cn ?? row?.content))
        .filter((t): t is string => Boolean(t && String(t).trim())),
    [lines, isEn],
  );

  const [closed, setClosed] = useState(false);

  if (closed) {
    return null;
  }

  const alertNode =
    texts.length > 0 ? (
      <Alert
        type="info"
        visible
        onClose={() => setClosed(true)}
        hideIcon={texts.length > 1}
        className="dbh-pr-marquee-alert"
      >
        {texts.length === 1 ? (
          texts[0]
        ) : (
          <List type="bullet">
            {texts.map((info, index) => (
              <List.Item className="dbh-pr-marquee-alert__content" key={index}>
                {info}
              </List.Item>
            ))}
          </List>
        )}
      </Alert>
    ) : null;

  return (
    <Abnormal
      className="dbh-pr-marquee-alert__state"
      isLoading={loading}
      isError={isError}
      isNoData={!loading && !isError && texts.length === 0}
      component={alertNode}
    />
  );
};

export default PrMarqueeAlert;
